import React from 'react';
import {inject, observer} from 'mobx-react';
import {Route, Redirect} from 'react-router-dom';

@inject('sessionStore')
@observer
class AuthenticatedRoute extends React.Component {
  render() {
    const {authLevel, component: C, props: cProps, sessionStore, ...rest} = this.props;
    return (
      <Route
        {...rest}
        render={(props) => {
          // 未登录， 导入到登录页
          if (!sessionStore.currentUser && !sessionStore.isSsoLogin) {
            sessionStore.redirectToLogin(`${props.location.pathname}${props.location.search}`);
            return '';
          }

          // 无相关权限，进入not-found页面
          if (props.location.pathname !== '/company-select' && !authLevel.includes(sessionStore.userPermissionType)) {
            return <Redirect to='/404' />;
          }

          return <C {...rest} {...props} {...cProps} />;
        }}
      />
    );
  }
}

export default AuthenticatedRoute;
